import { Icon, IconVariant } from '@/components/Icon';
import classnames from '@/utilities/classnames';

export enum CheckmarkVariant {
  Standard = 'Checkmark--standard',
  Round = 'Checkmark--round',
}

export const Checkmark = ({
  checked,
  variant = CheckmarkVariant.Standard,
}: {
  checked: boolean;
  variant?: CheckmarkVariant;
}) => (
  <span
    className={classnames('Checkmark', variant, {
      'Checkmark--checked': checked,
    })}
  >
    <Icon variant={IconVariant.Checkmark} />
  </span>
);
